import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import DesktopMacOutlinedIcon from "@mui/icons-material/DesktopMacOutlined";
import CloseIcon from "@mui/icons-material/Close";

const STORAGE_KEY = "mobile_banner_dismissed";

// Read the actually-visible viewport. The app's desktop layout is wider than a
// phone, so the page scrolls horizontally and the layout viewport is wider than
// the screen. visualViewport reports the real visible region so the banner can
// be pinned to it instead of overflowing off-screen.
const getViewport = () => {
  const vv = window.visualViewport;
  return {
    width: vv?.width ?? window.innerWidth,
    left: vv?.offsetLeft ?? 0,
  };
};

const MobileBanner: React.FC = () => {
  const [viewport, setViewport] = useState(getViewport);
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(STORAGE_KEY) === "true"
  );

  const isMobile = viewport.width <= 768;

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setDismissed(true);
  };

  useEffect(() => {
    const update = () => setViewport(getViewport());
    const vv = window.visualViewport;
    window.addEventListener("resize", update);
    vv?.addEventListener("resize", update);
    vv?.addEventListener("scroll", update);
    return () => {
      window.removeEventListener("resize", update);
      vv?.removeEventListener("resize", update);
      vv?.removeEventListener("scroll", update);
    };
  }, []);

  if (!isMobile || dismissed) return null;

  return createPortal(
    <div
      style={{
        position: "fixed",
        top: 12,
        left: viewport.left + 12,
        width: viewport.width - 24,
        boxSizing: "border-box",
        zIndex: 9999,
        background: "#2A2342",
        color: "#fff",
        borderRadius: 14,
        padding: "14px 18px",
        boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
        display: "flex",
        alignItems: "flex-start",
        gap: 12,
      }}
    >
      <DesktopMacOutlinedIcon style={{ fontSize: 22, marginTop: 2, flexShrink: 0, color: "#C9BCFF" }} />
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>
          Better on desktop
        </div>
        <div style={{ fontSize: 13, lineHeight: 1.4, color: "#C9BCFF" }}>
          Some controls are cramped here — switch when you can.
        </div>
      </div>
      <button
        onClick={handleDismiss}
        aria-label="Dismiss"
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0,
          color: "#fff",
          opacity: 0.7,
          flexShrink: 0,
        }}
      >
        <CloseIcon style={{ fontSize: 18 }} />
      </button>
    </div>,
    document.body
  );
};

export default MobileBanner;
